import { VideoTrack } from "@livekit/components-react";
import * as React from "react";
import { resolveParticipantDisplayName } from "../utils/liveInterviewDisplayUtils";
import {
  useLiveInterviewTabPresence,
  useScreenShareDisplaySurface,
} from "../utils/liveInterviewTabPresence";

export function LiveInterviewRemoteScreenShareVideo({
  trackRef,
  onSubscriptionStatusChanged,
  manageSubscription,
  roomKey,
}) {
  const [forceShow, setForceShow] = React.useState(false);
  const { isMultiTabInRoom } = useLiveInterviewTabPresence(roomKey);
  const displaySurface = useScreenShareDisplaySurface(trackRef);
  const presenterName = resolveParticipantDisplayName(trackRef?.participant);

  const isEntireScreenShare = displaySurface === "monitor";
  const useSafePanel = isEntireScreenShare && isMultiTabInRoom && !forceShow;

  if (useSafePanel) {
    return (
      <div className="li-remote-share-safe-panel" role="status" aria-live="polite">
        <p className="li-remote-share-safe-title">{presenterName} is sharing their entire screen</p>
        <p className="li-remote-share-safe-body">
          You have more than one meeting tab open on this device. Showing the live share here can
          create a mirror loop for the presenter. Ask them to share a specific Chrome tab or app
          window instead of Entire screen, or test from two separate devices.
        </p>
        <button
          type="button"
          className="li-remote-share-safe-btn"
          onClick={() => setForceShow(true)}
        >
          Show share anyway
        </button>
      </div>
    );
  }

  return (
    <VideoTrack
      trackRef={trackRef}
      onSubscriptionStatusChanged={onSubscriptionStatusChanged}
      manageSubscription={manageSubscription}
    />
  );
}
